import { MODES } from '@/fish/lib/enums'
import urls from '@/lib/urls'
import router from '@/router'

/**
 * Gets the mode the app is currently in.  Takes multiple options into account.
 * - url takes priority
 * - checking browser local storage
 * - defaults to vertical value
 * @returns {string}
 * @throws throws an error if not called in backcountry or offroad
 */
export const getMode = () => {
  return modeOverwrite() || modeStorage() || defaultMode()
}

const modeOverwrite = () => {
  return urls.getModeParam() || router?.currentRoute?.value?.params?.mode
}

const modeStorage = () => MODES.FRESHWATER

/**
 * *(AI-generated)*
 * Returns the default mode for the current vertical.
 */
export const defaultMode = () => MODES.FRESHWATER
